/**
 * ONE INTEGER HASH, shared by everything in the renderer that must be a pure function of a
 * world coordinate: the islet field (islets.ts) and the open-water phase field (water.ts).
 * Deterministic across platforms, so two tabs at the same instant place the same things.
 */

/** A 32-bit integer hash over four integers. */
export function hash32(a: number, b: number, c: number, d: number): number {
  let h = (a | 0) * 0x9e3779b1;
  h = Math.imul(h ^ (h >>> 15), 0x85ebca6b) ^ (b | 0);
  h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35) ^ (c | 0);
  h = Math.imul(h ^ (h >>> 16), 0x27d4eb2f) ^ (d | 0);
  h = Math.imul(h ^ (h >>> 15), 0x165667b1);
  return (h ^ (h >>> 13)) >>> 0;
}

/** Unit interval from a hash. */
export function unit(h: number): number {
  return h / 4294967296;
}
